import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
import createPersistedState from 'vuex-persistedstate';
import auth from './auth';
import user from './user';
import content from './content';
import googleClassroom from './google-classroom';

Vue.use(Vuex);

const stores = _.merge(auth, user, content, googleClassroom);
const { state, getters, mutations, actions } = stores;

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state,
  getters,
  mutations,
  actions,
});
